<div class="close-button-wrapper">
    <button id="closebutton" aria-label="close filter options" type="button"
(click)="closeDialog()">CLOSE <span class="material-symbols-outlined cancel-icon">
    cancel
</span> </button>
</div>
<div class="dialog-wrapper" aria-label="submission dialog">
    <i class="confirm" data-feather="check-circle"></i>

    <div *ngIf="!data.isEditing">
    <h1>Success</h1>
    <h2>Your CPD plan has been submitted to the Law Society of Alberta</h2>
    <h3>{{submittedDate}}</h3>
    <p>You have fulfilled your requirements under Rule 67.2 for this year. You can come back to this Tool to track your
        progress on your chosen competencies as you complete your learning activities. You can also edit your plan
        throughout the year if your goals change or you want to add additional competencies or activities to your plan.
        Your
        plan is available for download at any time, but you can do so now by clicking the button below to save or print
        your
        plan for your records.</p>
    </div>
    <div *ngIf="data.isEditing">
        <h1>Success</h1>
        <h2>Your edited CPD plan has been submitted to the Law Society of Alberta</h2>
        <h3>{{submittedDate}}</h3>
        <p>Your updated plan is available for download at any time, but you can do so now by clicking the buttons below to save or print your plan for your records. You can come back to this Tool to track your progress on your chosen competencies as you complete your learning activities.</p>
    </div>

    <p class="plan-pdf-message">
        You can download and/or email your CPD plan(s) by selecting the full plan, simplified plan, or both plans option in the dropdowns below. The CPD plan(s) will automatically download or email once an option is selected.
    </p>

    <div class="plan-pdf-buttons">
        <button type="button" mat-raised-button role="menu" color="primary" class="buttonClass download-menu-btn" [matMenuTriggerFor]="downloadMenu" [disabled]="isDownloadingPdf" aria-label="Download Plan">
            <span *ngIf="!isDownloadingPdf">DOWNLOAD PLAN</span>
            <span *ngIf="isDownloadingPdf">GENERATING PLAN...</span>
            <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #downloadMenu="matMenu" class="download-menu" yPosition="below">
            <button appNoDblClick type="button" mat-menu-item (click)="downloadPdf(false)" class="buttonClass">Full Plan (PDF)</button>
            <button appNoDblClick type="button" mat-menu-item (click)="downloadPdf(true)" class="buttonClass">Simplified Plan (PDF)</button>
            <button appNoDblClick type="button" mat-menu-item (click)="downloadPdf()" class="buttonClass">Both Plans (PDFs)</button>
        </mat-menu>

        <button type="button" mat-raised-button role="menu" color="primary" class="buttonClass email-menu-btn" [matMenuTriggerFor]="emailMenu" [disabled]="isSendingPdfEmail" aria-label="Email Plan">
            <span *ngIf="!isSendingPdfEmail">EMAIL PLAN</span>
            <span *ngIf="isSendingPdfEmail">EMAILING PLAN...</span>
            <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <span class="material-symbols-outlined email-tooltip" matTooltipPosition="right" [matTooltip]="'The selected CPD plan(s) will be emailed to ' + (profile?.member?.email_no || '') +  '. If you want to change your email address, you will need to close this CPD Tool to edit your personal information in the Lawyer Portal. Close the CPD Tool and open the Lawyer Portal.'">
            info
        </span>
        <mat-menu #emailMenu="matMenu" class="email-menu" yPosition="below">
            <button appNoDblClick type="button" mat-menu-item (click)="emailPdf(false)" class="buttonClass">Full Plan (PDF)</button>
            <button appNoDblClick type="button" mat-menu-item (click)="emailPdf(true)" class="buttonClass">Simplified Plan (PDF)</button>
            <button appNoDblClick type="button" mat-menu-item (click)="emailPdf()" class="buttonClass">Both Plans (PDFs)</button>
        </mat-menu>
    </div>

    <div class="loading-box" [ngStyle]="{ 'grid-template-columns' : (isDownloadingPdf && isSendingPdfEmail) ? '50% 50%' : '100%'}">
        <div *ngIf="isDownloadingPdf" class="item success message-success-container">
            <app-inline-spinner class="inline-spinner" [height]="24" [width]="24" aria-hidden="true"></app-inline-spinner>
            <div class="success-message" aria-live="polite" role="alert">
                <span aria-hidden="true">Your selected CPD plan(s) are being generated. You can access the CPD plan(s) by viewing your Downloads folder.</span>
                <span class="sr-only">Your selected CPD plans are being generated. You can access the CPD plans by viewing your Downloads folder.</span>
            </div>
        </div>
        <div *ngIf="isSendingPdfEmail" class="item success message-success-container">
            <app-inline-spinner class="inline-spinner" [height]="24" [width]="24" aria-hidden="true"></app-inline-spinner>
            <div class="success-message" aria-live="polite" role="alert">
                <span aria-hidden="true">Your selected CPD plan(s) are being generated. You will receive an email that includes the CPD plan(s) in the next few minutes.</span>
                <span class="sr-only">Your selected CPD plans are being generated. You will receive an email that includes the CPD plans in the next few minutes.</span>
            </div>
        </div>
    </div>

    <div class="feedback-wrapper" *ngIf="!data.isEditing">
        <span>We want your feedback!</span>
        <p>Please rate your experience (5 = Excellent) with the Tool and Self-Assessment and Planning Process below.
        </p>
        <div class="answer-wrapper">
            <div [hidden]="submitted">
                <h3>Rate your experience with the CPD Tool:</h3>
                <app-star-rating [(rating)]="toolRating" type="tool" (ratingChange)="onFeedbackChange()"></app-star-rating>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Comments</mat-label>
                    <textarea aria-label="Comment on CPD tool rating" [name]='"tool"'
                        [(ngModel)]="feedback.ToolComments" (ngModelChange)="onFeedbackChange()" matInput [maxLength]="500" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" appValidatePastedSpecialCharacter appValidateSpecialCharacter></textarea>
                        <div class="validation-error" *ngIf="feedback.ToolComments?.length >= 500">Maximum character limit reached.</div>
                </mat-form-field>
                <h3>Rate your experience with the CPD Self-Assessment and Planning process:</h3>
                <app-star-rating [(rating)]="processRating" type="process" (ratingChange)="onFeedbackChange()"></app-star-rating>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Comments</mat-label>
                    <textarea aria-label="Comment on Self-Assessment and planning process" [name]='"planning"'
                        [(ngModel)]="feedback.ProcessComments" (ngModelChange)="onFeedbackChange()" matInput [maxLength]="500" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" appValidatePastedSpecialCharacter appValidateSpecialCharacter></textarea>
                        <div class="validation-error" *ngIf="feedback.ProcessComments?.length >= 500">Maximum character limit reached.</div>
                </mat-form-field>
                <button appNoDblClick class="submit-button buttonClass" type="button" mat-raised-button color="primary" [disabled]="!isFeedbackValid"
                    (click)="submitFeedback()">SUBMIT FEEDBACK</button>
            </div>
            <div [hidden]="!submitted">
                <span>Thank you for your feedback.</span>
            </div>
        </div>
    </div>
</div>
